import { useMemo } from 'react';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { AuthLoadingComponent } from '../loaders/AuthLoadingComponent';
import { createMsalAuthClient } from './createMsalAuthClient';
import { jsx as _jsx } from "react/jsx-runtime";
export const MsalAuthOverlay = _ref => {
  let {
    authConfig,
    children
  } = _ref;
  const authClient = useMemo(() => createMsalAuthClient(authConfig), [authConfig]);
  return (
    /*#__PURE__*/
    // msal-browser v3+ requires initialize() to resolve before any interaction API is used, but MsalProvider handles it internally
    _jsx(MsalProvider, {
      instance: authClient,
      children: /*#__PURE__*/_jsx(MsalAuthenticationTemplate, {
        interactionType: InteractionType.Redirect,
        loadingComponent: MsalLoadingComponent,
        authenticationRequest: {
          scopes: [authConfig.clientCredentialsFlowScope]
        },
        children: children
      })
    })
  );
};
const MsalLoadingComponent = _ref2 => {
  let {
    inProgress
  } = _ref2;
  return /*#__PURE__*/_jsx(AuthLoadingComponent, {
    status: inProgress
  });
};